import { isPlatformBrowser } from '@angular/common';
import { Auth } from '@freelancer/auth';
import { take } from 'rxjs/operators';
/*
 * This uses Google's global site tag (gtag.js) snippet, which replaced the old
 * Universal Analytics (analytics.js) and other product-specific SDKs and
 * allows to communicate to Google Analytics, Google Ads, and Google Marketing
 * Platform.
 */
var GoogleTracking = /** @class */ (function () {
    function GoogleTracking(auth, config, platformId) {
        this.auth = auth;
        this.config = config;
        this.platformId = platformId;
        this.isEnabled = false;
        if (this.config.gaTrackingId && isPlatformBrowser(this.platformId)) {
            this.isEnabled = true;
            window.dataLayer = window.dataLayer || [];
        }
    }
    GoogleTracking.prototype.trackPageView = function () {
        var _this = this;
        if (!this.isEnabled) {
            return;
        }
        this.auth.authState$
            .pipe(take(1))
            .toPromise()
            .then(function (auth) {
            _this.gtag('config', _this.config.gaTrackingId, {
                user_id: auth ? auth.userId : undefined,
                page_location: window.location.href,
                page_path: window.location.pathname,
            });
        });
    };
    GoogleTracking.prototype.trackClickEvent = function (payload) {
        var _this = this;
        if (!this.isEnabled) {
            return;
        }
        this.auth.authState$
            .pipe(take(1))
            .toPromise()
            .then(function (auth) {
            _this.gtag('event', 'click', {
                event_category: payload.section,
                event_label: payload.label,
            });
        });
    };
    GoogleTracking.prototype.gtag = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.loadTrackingSnippet();
        // We do need arguments here as GA does weird things with it, e.g. probably
        // reading the caller/callee or something, as just passing args doesn't
        // work (silentely fails & nothing is tracked).
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
    };
    GoogleTracking.prototype.loadTrackingSnippet = function () {
        if (!document.getElementById('gtag-sdk')) {
            var e = document.createElement('script');
            e.type = 'text/javascript';
            e.src = "https://www.googletagmanager.com/gtag/js?id=" + this.config.gaTrackingId;
            e.id = 'gtag-sdk';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(e, s);
            this.gtag('js', new Date());
            this.gtag('config', this.config.gaTrackingId, {
                // automatic page view tracking is disabled as we manually send page
                // view events to track the SPA route changes
                send_page_view: false,
                // use navigator.sendBeacon when supported. will be the default in a
                // future release.
                transport_type: 'beacon',
            });
            // Enable AdWords conversion tracking and remarketing
            if (this.config.awGoogleConversionId) {
                this.gtag('config', this.config.awGoogleConversionId);
            }
        }
    };
    return GoogleTracking;
}());
export { GoogleTracking };
